import React from 'react';
import { NavLink } from 'react-router-dom';

interface NavigationProps {
  className?: string;
  variant?: 'light' | 'dark';
}

export const Navigation: React.FC<NavigationProps> = ({ className = "", variant = 'dark' }) => {
  const navItems = [
    { name: "Work", path: "/" },
    { name: "Profile", path: "/profile" }
  ];

  return (
    <nav className={className}>
      <ul className="flex flex-row items-center gap-[32px] [font-family:'ItemsTextTrial-Light',Helvetica] font-light text-sm md:text-base">
        {navItems.map((item, index) => (
          <li key={index} className="hover:opacity-70 transition-all duration-300 cursor-pointer">
            <NavLink 
              to={item.path}
              className={({ isActive }) => 
                `${variant === 'light' ? 'text-white' : 'text-black'} ${
                  isActive ? 'text-[#0048FF] font-medium' : ''
                } transition-colors duration-300 block py-2 px-1 touch-manipulation`
              }
              end={item.path === '/'}
              onClick={() => {
                console.log('Navigation clicked:', item.name, item.path);
              }}
              style={{
                WebkitTapHighlightColor: 'transparent',
                WebkitTouchCallout: 'none',
                WebkitUserSelect: 'none',
                userSelect: 'none'
              }}
            >
              {item.name}
            </NavLink>
          </li>
        ))}
      </ul>
    </nav>
  );
};